// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-right-sidebar{box-shadow:rgba(0,0,0,.03) -1px 0px -3px;border-left:rgba(0,0,0,.04) 1px solid;background-image:linear-gradient(var(--background), var(--background--opacity));display:flex;flex-direction:column;justify-content:space-between;position:fixed;z-index:10}.c-right-sidebar--backdrop{background:var(--background--highlight);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.c-right-sidebar__actions--dnc svg path{fill:#dfa51d}", ""]);
// Exports
module.exports = exports;
